(() => {
  "use strict";

  const SELECTORS = {
    root: "[data-ps-root]",
    results: "[data-ps-results]",
    slot: "[data-ps-events-slot]",
    input:
      "#search-input, #search-input-mobile, .predictive-search_input[name='q'], input[type='search'][name='q'], input[name='q']",
    index: "#ps-events-index",
    emptyMessage: "[data-ps-empty-message]" // NEW
  };

  function escapeHtml(str) {
    return String(str ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function normalize(str) {
    return String(str || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function getRoot() {
    const roots = Array.from(document.querySelectorAll(SELECTORS.root));
    if (!roots.length) return null;

    const inOverlay = roots.find((r) =>
      r.closest("#predictive-search, .predictive-search_component, .predictive-search_overflow")
    );
    return inOverlay || roots[0];
  }

  // NEW: show/hide the Liquid "Nothing found" block when Events has matches
  function setEmptyMessageVisible(resultsEl, visible) {
    if (!resultsEl) return;
    const empty = resultsEl.querySelector(SELECTORS.emptyMessage);
    if (!empty) return;
    empty.style.display = visible ? "" : "none";
  }

  // Cache events per-root instance so we do not JSON.parse repeatedly
  function readEventsIndex(root) {
    if (!root) return [];
    if (root.__psEventsCached) return root.__psEventsCached;

    const script = root.querySelector(SELECTORS.index);
    if (!script) return (root.__psEventsCached = []);

    try {
      const arr = JSON.parse(script.textContent || "[]");
      if (!Array.isArray(arr)) return (root.__psEventsCached = []);
      return (root.__psEventsCached = arr
        .filter((x) => x && x.title && x.url)
        .map((x) => ({ ...x, __title_norm: normalize(x.title) })));
    } catch {
      return (root.__psEventsCached = []);
    }
  }

  function buildEventCard(e) {
  const url = e?.url || "#";
  const title = e?.title || "Event";
  const img = e?.image || "";
  const dateLabel = e?.date_label || "";
  const priceLabel = e?.price_label || "";

  const imgHtml = img
    ? `
      <div class="predictive-search_image-wrapper">
        <img src="${escapeHtml(img)}" alt="${escapeHtml(title)}" class="predictive-search_image" loading="lazy">
      </div>`
    : `<div class="predictive-search_image-wrapper"></div>`;

  const metaHtml = (dateLabel || priceLabel)
    ? `
      <div class="text-size-small predictive-search_event-meta">
        ${dateLabel ? `<span class="predictive-search_event-date">${escapeHtml(dateLabel)}</span>` : ""}
        ${dateLabel && priceLabel ? `<span class="predictive-search_event-separator"> | </span>` : ""}
        ${priceLabel ? `<span class="predictive-search_event-price">${escapeHtml(priceLabel)}</span>` : ""}
      </div>
    `
    : "";

  return `
    <li class="predictive-search_product-item">
      <a href="${escapeHtml(url)}" class="predictive-search_line-item w-inline-block">
        ${imgHtml}
        <div class="predictive-search_product-info">
          <div class="text-size-regular is-cardo">${escapeHtml(title)}</div>
          ${metaHtml}
        </div>
      </a>
    </li>
  `;
  }

  function renderEventsIntoSlot(root, term) {
    const resultsEl = root.querySelector(SELECTORS.results);
    if (!resultsEl) return;

    const slot = resultsEl.querySelector(SELECTORS.slot);
    if (!slot) return;

    const nterm = normalize(term);

    if (nterm.length < 2) {
      slot.innerHTML = "";
      // NEW: restore empty message visibility when term is too short
      setEmptyMessageVisible(resultsEl, true);
      return;
    }

    const eventsAll = readEventsIndex(root);
    const matches = eventsAll.filter((ev) => ev.__title_norm.includes(nterm)).slice(0, 6);

    // NEW: hide "Nothing found" when Events has matches
    setEmptyMessageVisible(resultsEl, matches.length === 0);

    slot.innerHTML = matches.length
      ? `
        <div class="predictive-search_topic">
          <div class="predictive-search_headline">
            <div class="text-style-muted is-cardo">Events</div>
          </div>
          <ul role="list" class="predictive-search_product-list w-list-unstyled">
            ${matches.map(buildEventCard).join("")}
          </ul>
        </div>
      `
      : "";
  }

  function attachResultsObserver(root, input) {
    const resultsEl = root.querySelector(SELECTORS.results);
    if (!resultsEl || resultsEl.__psEventsObs) return;

    let rafPending = false;
    const mo = new MutationObserver(() => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;

        // PATCH: choose the root associated with the active input first
        const freshRoot = input.closest(SELECTORS.root) || getRoot();

        if (freshRoot) renderEventsIntoSlot(freshRoot, input.value || "");
      });
    });

    mo.observe(resultsEl, { childList: true, subtree: true });
    resultsEl.__psEventsObs = mo;
  }

  function mount() {
    const input = document.querySelector(SELECTORS.input);
    if (!input) return;

    const run = () => {
      // PATCH: choose the root associated with this input first
      const root = input.closest(SELECTORS.root) || getRoot();
      if (!root) return;

      attachResultsObserver(root, input);
      renderEventsIntoSlot(root, input.value || "");
    };

    input.addEventListener("input", run, { passive: true });
    input.addEventListener("focus", run, { passive: true });

    run();
  }

  document.addEventListener("DOMContentLoaded", mount);
})();
